"use client";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import Image from "next/image";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function CategorySection() {
	const t = useTranslations();
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		// 初始化时设置
		handleResize();

		// 监听窗口大小变化
		window.addEventListener("resize", handleResize);

		// 清理监听
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const categories = [
		{
			name: t("home.ct1"),
			image: "/image/home/1.webp",
			url: "/products/Mobile",
		},
		{
			name: t("home.ct2"),
			image: "/image/home/2.webp",
			url: "/products/portable-solar-panels",
		},
		{
			name: t("home.ct3"),
			image: "/image/home/3.webp",
			url: "/products/sets",
		},
		{
			name: t("home.ct4"),
			image: "/image/home/4.webp",
			url: "/products/lifestyle",
		},
	];

	const CategoryCard = ({ category, index }) => (
		<Link
			href={category.url}
			key={index}
			className="group block w-[345px] max-md:w-[300px]"
			aria-label={`${category.name} category`}
		>
			<article className="w-full overflow-hidden border border-gray-500 bg-gray-100 transition-all duration-300 hover:shadow-lg max-md:w-[300px]">
				<figure className="relative h-[345px] w-[345px] overflow-hidden max-md:w-[300px]">
					<Image
						src={category.image}
						alt={`${category.name} category image`}
						fill
						className="object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
					/>
					<figcaption className="absolute inset-0">
						<header className="p-4">
							<h3 className="font-marr inline-block rounded px-2 py-1 text-[24px] font-bold uppercase text-black max-md:text-[18px]">
								{category.name}
							</h3>
						</header>

						<div className="absolute bottom-0 left-0 w-full translate-y-full transform opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 max-md:hidden">
							<div className="flex h-[50px] w-full items-center justify-center bg-gradient-to-b from-[rgba(209,209,209,0.9)] via-[rgba(180,180,180,0.8)] to-main text-black shadow-inner">
								<span className="font-marr text-[22px] font-medium">{t("home.Shop Now")}</span>
							</div>
						</div>
					</figcaption>
				</figure>
			</article>
		</Link>
	);

	return (
		<section className="pb-8 pt-16" aria-labelledby="category-section-title">
			<div className="container">
				<header className="flex flex-col items-center gap-2">
					<h2
						id="category-section-title"
						className="font-queens group relative mb-4 text-center text-[32px] font-medium md:text-[42px] lg:text-[52px]"
					>
						{t("home.ct5")}
						<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span>
					</h2>
				</header>
				{isMobile ? (
					<Swiper
						slidesPerView={1.15}
						spaceBetween={10}
						autoplay={{
							delay: 3000,
							disableOnInteraction: false,
						}}
						loop={true}
						modules={[Autoplay]}
						className="w-full"
						aria-label="Categories slider"
					>
						{categories.map((category, index) => (
							<SwiperSlide key={index} className="py-2">
								<CategoryCard category={category} index={index} />
							</SwiperSlide>
						))}
					</Swiper>
				) : (
					<div className="flex flex-wrap justify-center gap-8" role="list">
						{categories.map((category, index) => (
							<div key={index} role="listitem">
								<CategoryCard category={category} index={index} />
							</div>
						))}
					</div>
				)}
			</div>
		</section>
	);
}
